import script from "./IndicatorsStatisticChart.vue?vue&type=script&setup=true&lang=ts"
export * from "./IndicatorsStatisticChart.vue?vue&type=script&setup=true&lang=ts"

import "./IndicatorsStatisticChart.vue?vue&type=style&index=0&id=74481dc6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74481dc6"]])

export default __exports__